/* RESPONSIBLE TEAM: team-actions */
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneProcedureSectionRoute extends Route {
  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneProcedureSectionRoute, {
  overrideRenderTemplate: false,
});
